module.exports = __webpack_public_path__ + "static/img/X7声光报警器.c0b6fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD200/X7声光报警器.png
// module id = 4Zym
// module chunks = 0